module.exports = __webpack_public_path__ + "ab83191ebefbd7f551c53a4e4272ba97.pdf";